import { makeStyles } from '@material-ui/core'

const styles = makeStyles(() => ({
  chip: {
    fontWeight: 600,
    textTransform: 'uppercase',
  },
}))

export default styles
